import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue';


export const prijavaService = {
   loadOne,saveOne
    
};


function loadOne(sezona,pridelovalecid,shema,pravice) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/prijava/${shema}/${sezona}/${pridelovalecid}/${pravice}`, requestOptions)
        .then(handleResponse)
        .then(kontrola => {
            // login successful if there's a jwt token in the response
            
            return kontrola;
        });
}

function saveOne(prijava,sezona,pridelovalecid,shema,pravice) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(prijava)
    };
    console.log(prijava);
    return fetch(`${Vue.prototype.$config.apiUrl}/prijava/${shema}/${sezona}/${pridelovalecid}/${pravice}`, requestOptions).then(handleResponse);
}

